module.exports = __webpack_public_path__ + "img/facebook.d79b9ea.png";